export default __webpack_public_path__ + "assets/images/i_home.2f8c354.png";